module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option [value]=\"null\">Select an option</option>\r\n  <option *ngFor=\"let o of options\" [value]=\"o.value\">{{o.label}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-tabs-penalty-expense-select/ztsi-tabs-penalty-expense-select.component.html
// module id = ./src/app/components/shared/ztsi-tabs-penalty-expense-select/ztsi-tabs-penalty-expense-select.component.html
// module chunks = main